import { ContentType } from "@openeducation/hr-rn-shared-types";
import FileSaver from "file-saver";

export const saveFile = (
  fileContent: string,
  fileName: string,
  contentType: ContentType = "text/csv;charset=utf-8" as ContentType
) => {
  const blob = new Blob([fileContent], {
    type: contentType,
  });
  FileSaver.saveAs(blob, fileName);
};
